// Receive-side identity for shared pigeons.
//
// The ring saved on a bird is the form's combined value (for example
// "GPU 1234"), while `year` is stored separately.  A possible duplicate share
// deliberately ignores the leading ring letters and compares only the ring
// numbers component + year.  Keep this policy isolated from ordinary Add Bird
// validation: it is specifically the browser-only sharing contract.

export const normalizeSharedRingNumbers = (ringNumber) => {
  const raw = String(ringNumber || '').trim();
  if (!raw) return '';

  // AddBird combines `ring_letters` before `ring_numbers`. Strip only that
  // leading run of letters; embedded letters remain part of the number section
  // (for example "ZA 21 MOUN 250" -> "21MOUN250").
  const withoutLetters = raw.replace(/^[A-Za-z]+/, '').replace(/^[\s/\\_.-]+/, '');
  return withoutLetters.toUpperCase().replace(/[\s/\\_.-]+/g, '');
};

export const sharedPigeonIdentity = (bird) => {
  const ringNumbers = normalizeSharedRingNumbers(bird?.ring_number);
  const year = Number(bird?.year);
  if (!ringNumbers || !Number.isInteger(year) || year <= 0) return null;
  return `${ringNumbers}::${year}`;
};

export const findSharedPigeonConflicts = (incomingBirds = [], existingBirds = []) => {
  const existingByIdentity = new Map();
  for (const bird of existingBirds) {
    if (bird?.is_test) continue;
    const identity = sharedPigeonIdentity(bird);
    if (!identity) continue;
    if (!existingByIdentity.has(identity)) existingByIdentity.set(identity, []);
    existingByIdentity.get(identity).push(bird);
  }

  const conflicts = [];
  for (const incoming of incomingBirds) {
    const identity = sharedPigeonIdentity(incoming);
    const candidates = identity ? (existingByIdentity.get(identity) || []) : [];
    if (candidates.length) {
      conflicts.push({ incomingId: incoming.id, identity, incoming, candidates });
    }
  }
  return conflicts;
};

